import { useDialog } from '@app/core/hooks';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { SimpleTable } from '../../components/base/SimpleTable';
import { categorizeHotkeys } from './categorize-hotkeys';
import { HotkeyDisplay } from './HotkeyDisplay';
import { HotkeysRegistry } from './hotkeys.types';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly hotkeys: HotkeysRegistry<any>;
  readonly className?: string;
}

export function HotkeysDialog(props: Props) {
  const { hotkeys, className } = props;
  const { formatMessage, $t } = useIntl();
  const { open, onOpen, onClose } = useDialog();
  const categorizedHotkeys = categorizeHotkeys(hotkeys, $t);

  return (
    <>
      <Tooltip
        title={formatMessage({
          id: 'core.screen.hotkeys.showBtnText',
          defaultMessage: 'Atajos',
        })}
      >
        <IconButton
          size="small"
          onClick={onOpen}
          className={className}
          aria-label={formatMessage({
            id: 'core.screen.hotkeys.showBtnText',
            defaultMessage: 'Atajos',
          })}
        >
          <KeyboardIcon />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center" gap={1}>
            <KeyboardIcon />
            <FormattedMessage
              id="core.screen.hotkeys.modalTitle"
              defaultMessage="Atajos de teclado"
            />
            <Box sx={{ flexGrow: 1 }} />
            <IconButton
              aria-label={$t({
                id: 'common.close',
                defaultMessage: 'Cerrar',
              })}
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ '& > * + *': { mt: 2 } }}>
          {categorizedHotkeys.map((section, sectionIndex) => {
            const hotkeyIds = Object.keys(section.hotkeys);
            const rows = hotkeyIds.map((id) => {
              const hotkey = section.hotkeys[id];
              return [
                hotkey.label,
                {
                  content: <HotkeyDisplay hotkey={hotkey.key} />,
                  props: {
                    align: 'center' as const,
                    sx: { width: '50%' },
                  },
                },
              ];
            });

            return (
              <SimpleTable key={sectionIndex} headers={[section.categoryLabel, '']} rows={rows} />
            );
          })}
        </DialogContent>
      </Dialog>
    </>
  );
}
